import {
  SEND_CLIENT_DOWNLOAD_DUMP,
  SEND_CLIENT_DOWNLOAD_DUMP_SUCCESS,
  SEND_CLIENT_DOWNLOAD_DUMP_ERROR,
  SEND_CLIENT_DOWNLOAD_DUMP_EMPTY,
} from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ClientDownloadDump = (state = initialState, action) => {
  switch (action.type) {
    case SEND_CLIENT_DOWNLOAD_DUMP:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case SEND_CLIENT_DOWNLOAD_DUMP_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case SEND_CLIENT_DOWNLOAD_DUMP_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case SEND_CLIENT_DOWNLOAD_DUMP_EMPTY:
      state = {
        data: null,
        message: null,
        loading: false,
        success: false,
        error: false,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ClientDownloadDump;
